import React from 'react'
import { Job, JobWizard } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizard.PostJobAgain = {
  displayName: 'PostJobAgain',

  onSubmit: function(onStepProgression, onRequest, onRequestCompletion, onStepRetreat) {
    onStepProgression()
  },
  
  component: React.createClass({
    componentWillUnmount: function() {
      $('#job-modal').find('.modal-footer').show()
    },

    moveToDescription: function () {
      var description = Job.Data.closureSurvey.job.description.split('Specific Job Details')[0]
      var subcategoryId = Job.Data.closureSurvey.job.subcategory_id
      var subcategory = Job.Data.closureSurvey.job.subcategory_name
      var suburbId = Job.Data.closureSurvey.job.suburb_id
      var suburb = Job.Data.closureSurvey.job.suburb

      Job.Actions.resetData()
      Job.Actions.updateCategory({ id: subcategoryId, value: subcategory })
      Job.Actions.updateSubCategory({id: subcategoryId, values: subcategory}, 'add')
      Job.Actions.updateLocation({ id: suburbId, value: suburb })
      Job.Actions.updateDescription(description)

      this.setState({currentStep: JobWizard.Steps[1]})
      JobWizard.Emitter.emit('job:wizard:advanceToStep', JobWizard.Description)
    },

    moveToFirstSlide: function () {
      Job.Actions.resetData()
      this.setState({currentStep: JobWizard.Steps[0]})
      JobWizard.Emitter.emit('job:wizard:advanceToStep', JobWizard.Details)
    },

    closeScreen: function() {
      let jobID = Job.Data.id
      let url = ''

      $('#job-modal').modal('hide')

      switch (Job.Data.referrer.cta) {
        case 'profile': {
          url = `/jobs/${jobID}/profilejob?successful_job=true`
        }
        case 'business_directory_card': {
          url = `/jobs/${jobID}/bcardjob?successful_job=true`
        }
        default: {
          url = `/jobs/${jobID}/posted?successful_job=true`
        }
      }

      document.location.href = url
    },

    render: function() {
      return (
        <div className="modal-body job-closure-form-body p0 pb32 pt20">
          {
            (Job.Data.closureSurvey.rating > 2) ?
              <div>
                <h3 className="pb16">Thanks for rating your experience.<br/>What else do you need done?</h3>
                <div className="row">
                  <div className="col-xs-12 pb24">
                    <a href="#" className="btn btn-block btn-clear btn-secondary radius-6" onClick={this.moveToFirstSlide}>
                      Find other great local businesses
                    </a>
                  </div>
                </div>
              </div>
            :
              <div>
                <h3>{`Thanks for rating ${Job.Data.closureSurvey.providerAccountName}.`}</h3>
                <div className="font-14 text-copy-0 pb24 pt20">
                  Do you still need someone for this job?
                </div>
                <div className="row">
                  <div className="col-xs-12 pb16">
                    <a href="#" className="btn btn-block btn-secondary radius-6" onClick={this.moveToDescription}>
                      Get new quotes
                    </a>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-12 pb24">
                    <a href="#" className="btn btn-block btn-clear btn-secondary radius-6" onClick={this.moveToFirstSlide}>
                      Get quotes for a different job
                    </a>
                  </div>
                </div>
                <div className="font-14 text-copy-0 pb20">
                  Don't worry - We won't let {Job.Data.closureSurvey.providerAccountName} see or quote on any job you post in the future.
                </div>
                <div className="row">
                  <div className="col-xs-12 text-center">
                    <a href="#" className="bold text-copy-0" onClick={this.closeScreen}>
                      Close this screen
                    </a>
                  </div>
                </div>
              </div>
          }
        </div>
      )
    }
  })
}
